import { Injectable, Injector } from '@angular/core';

import { environment } from '@environments/environment';
import { ConfiguratorMaintenance } from '@models';
import { ApiService, DefaultHttpHeaders } from '@services/api/api.service';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface GetMaintenanceParams extends DefaultHttpHeaders {}

@Injectable({
  providedIn: 'root',
})
export class MaintenanceService extends ApiService {
  maintenanceInd: boolean;
  constructor(protected readonly injector: Injector) {
    super(injector);
  }

  async getMaintenance(params: GetMaintenanceParams): Promise<ConfiguratorMaintenance> {
    return this.get<ConfiguratorMaintenance>({
      suffix: '/configurator/maintenance',
      apiUrl: environment.configuratorApiUrl,
    })
      .pipe(
        tap(data => {
          this.maintenanceInd = data.maintenanceInd ?? false;
        }),
        catchError(() => {
          this.maintenanceInd = false;
          return of();
        })
      )
      .toPromise();
  }
}
